module.exports = __webpack_public_path__ + "static/media/permission.42421d0d.png";